import { Injectable, NgZone } from '@angular/core';

import { Store } from '@ngrx/store';

import { HubConnection } from '@microsoft/signalr';

import { Device } from '@era/locations-sdk';

import { LocationsHubService } from '@era/core';
import { DeviceStoreActions } from '@era/stores';

@Injectable()
export class DevicesSignalR {
  private readonly hubConnection: HubConnection;

  constructor(
    private readonly zone: NgZone,
    locationsHubService: LocationsHubService,
    private readonly store: Store<Device>
  ) {
    this.hubConnection = locationsHubService.hubConnection;
    this.initialize();
  }

  private initialize() {
    this.hubConnection.on('OnDeviceChanged', (device: Device) => {
      this.zone.run(() => {
        this.store.dispatch(DeviceStoreActions.DeviceSignalRHubActions.deviceChanged({ device }));
      });
    });

    this.hubConnection.on('OnDeviceRemoved', (device: Device) => {
      this.zone.run(() => {
        this.store.dispatch(DeviceStoreActions.DeviceSignalRHubActions.deviceRemoved({ device }));
      });
    });
  }
}
